export { AspectRatio } from '@mantine/core'
